import { useNavigate } from "react-router-dom";

const PageNotFound = () => {
	const navigate = useNavigate();

	const goHome = () => {
		navigate("/");
	}

	const goBack = () => {
		navigate(-1);
	}

	return (
		<section className="bg-white">
			<div className="container flex items-center min-h-screen px-6 py-12 mx-auto">
				<div>
					<p className="text-sm font-medium text-teal-500">404 error</p>
					<h1 className="mt-3 text-2xl font-semibold text-gray-800 md:text-3xl">We can&rsquo;t find that page</h1>
					<p className="mt-4 text-gray-500">Sorry, the page you are looking for doesn&rsquo;t exist or has been moved.</p>

					<div className="flex items-center my-6 gap-x-3">
						<button onClick={goBack} className="flex items-center justify-center w-1/2 px-5 py-2 text-sm text-gray-700 transition-colors bg-white border rounded-sm gap-x-2 sm:w-auto gray-800 hover:bg-gray-100">
							<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-5 h-5 rtl:rotate-180">
								<path stroke-linecap="round" stroke-linejoin="round" d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18" />
							</svg>

							<span>Go back</span>
						</button>

						<button onClick={goHome} className="w-1/2 px-5 py-2 text-sm tracking-wide text-white transition-colors bg-teal-500 rounded-sm shrink-0 sm:w-auto hover:bg-teal-600 blue-500">
							All Projects
						</button>
					</div>

					<a className="text-gray-500 transition hover:text-gray-700" href="https://www.pauljoshi.com/">
						<span>Go to </span>
						<span className="underline">pauljoshi.com</span>
					</a>
				</div>
			</div>
		</section>
	)
}

export default PageNotFound
